import {Box, Card, CardHeader, Divider, Grid, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography, withStyles} from '@material-ui/core';
import {FiberManualRecord} from '@material-ui/icons';
import {BorderLinearProgress} from 'components/progress/border-linear-progress';
import Text from 'components/text';
import {autobind} from 'core-decorators';
import {reverse} from 'core/urls';
import {formatMoney} from 'core/utils';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import BoxIcon from './assets/box-icon';
import TransactionsIcon from './assets/transactions-icon';

@autobind
export default class ExpenditureByOrganization extends React.Component {
    static propTypes = {
        season: PropTypes.number.isRequired,
        expenditureByOrganization: PropTypes.array.isRequired,
    };

    state = {
        showMobileActionsId: null,
    };

    componenStyledTableCellidMount() {
        document.body.addEventListener('click', this.hideMobileActions);
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.hideMobileActions);
    }

    showMobileActions(id) {
        return () => this.setState({showMobileActionsId: id});
    }

    hideMobileActions() {
        this.setState({showMobileActionsId: null});
    }
    getQueryString(organization) {
        return `?organization=${organization.id}&season=${this.props.season}`;
    }
    getOrderListLink(organization) {
        return `${reverse('orderList')}${this.getQueryString(organization)}`;
    }
    getCreditSummaryLink(organization) {
        return `${reverse('creditSummary', {id: organization.id})}${this.getQueryString(organization)}`;
    }
    render() {
        const {expenditureByOrganization} = this.props;
        return (
            <Card>
                <CardHeader title={(<Text variant='h1' bold='bolder'>Detalle por organización</Text>)} disableTypography />
                <StyledTable>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell>Organización</StyledTableCell>
                            <StyledTableCell>Total</StyledTableCell>
                            <StyledTableCell />
                            <StyledTableCell>
                                <Box sx={{display: 'flex', alignItems: 'center', columnGap: 10}}>
                                    <FiberManualRecord color='primary' />
                                    Consumido
                                    <FiberManualRecord color='disabled' />
                                    Disponible
                                </Box>
                            </StyledTableCell>
                            <StyledTableCell />
                            <StyledTableCell align='center' size='small' padding='none'>Disponible</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {expenditureByOrganization.map(({organization, summary, transactionsByCategory}) => {
                            const hasTransactions = organization.createDealerOrders;
                            return (
                                <StyledTableRow hover key={organization.id}>
                                    <StyledTableCell>{organization.name.toUpperCase()}</StyledTableCell>
                                    <StyledTableCell>{hasTransactions && formatMoney(summary, 'total')}</StyledTableCell>
                                    <StyledTableCell padding='none' align='right'>
                                        <Text bold='bold' variant='h4' component='span'>
                                            {hasTransactions && formatMoney(summary, 'consumed')}
                                        </Text>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {hasTransactions && (
                                            <Tooltip
                                                arrow
                                                position='right'
                                                title={
                                                    <Fragment>
                                                        <Grid container spacing={1}>
                                                            {transactionsByCategory.map(({category, percentage}) => (
                                                                <Grid item xs={12} container justify='space-between' key={category.id}>
                                                                    <Typography variant='h3' component='span'>
                                                                        {category.name}
                                                                    </Typography>
                                                                    <Typography variant='h3' component='span'>
                                                                        {percentage}%
                                                                    </Typography>
                                                                </Grid>
                                                            ))}
                                                            <Grid item xs={12}>
                                                                <Divider color='white' />
                                                            </Grid>
                                                            {transactionsByCategory.length > 0 ? (
                                                                <Grid item xs={12} container justify='space-between'>
                                                                    <Typography variant='h3' component='span'>
                                                                        Total consumido
                                                                    </Typography>
                                                                    <Typography variant='h3' component='span'>
                                                                        {summary.consumedPercentage}%
                                                                    </Typography>
                                                                </Grid>
                                                            ) : (
                                                                <Grid item xs={12}>
                                                                    <Typography variant='h3'>Sin datos</Typography>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </Fragment>
                                                }
                                            >
                                                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: 4}} component='span'>
                                                    <BorderLinearProgress variant='determinate' value={summary.consumedPercentage} color='primary' />
                                                </Box>
                                            </Tooltip>
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell padding='none' align='left'>
                                        <Text bold='bold' variant='h4' component='span'>
                                            {hasTransactions && formatMoney(summary, 'available')}
                                        </Text>
                                    </StyledTableCell>
                                    <StyledTableCell align='center' size='small' padding='none'>
                                        <Box sx={{display: 'flex', justifyContent: 'center', columnGap: 4}}>
                                            <Tooltip title={<Text variant='h4'>Ver pedidos</Text>} arrow>
                                                <Link to={this.getOrderListLink(organization)}>
                                                    <BoxIcon fontSize='large' color='primary' />
                                                </Link>
                                            </Tooltip>
                                            {hasTransactions && (
                                                <Tooltip title={<Text variant='h4'>Ver transacciones</Text>} arrow>
                                                    <Link to={this.getCreditSummaryLink(organization)}  >
                                                        <TransactionsIcon fontSize='large' />
                                                    </Link>
                                                </Tooltip>
                                            )}
                                        </Box>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </StyledTable>
            </Card >
        );
    }
}

const StyledTable = withStyles((theme) => ({
    root: {
        fontSize: theme.typography.h3.fontSize,
        borderCollapse: 'collapse',
    },
}))(Table);

const StyledTableCell = withStyles(theme => ({
    head: {
        fontSize: theme.typography.h3.fontSize,
        fontWeight: 800,
    },
    body: {
        fontSize: theme.typography.h4.fontSize || '1.4rem',
        fontWeight: 600,
    },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
    hover: {
        opacity: 1,
    },
}))(TableRow);



// WEBPACK FOOTER //
// ./views/home/supervisor-home/expenditure-by-organization/index.js